import { useTranslation } from 'react-i18next'
import { GoBackButton, Heading } from '@repo/ui'
import PrivacyPolicy from '@/features/legal/PrivacyPolicy'

export default function PrivacyPolicyPage() {
  const { t } = useTranslation('common')
  const testIdInit = 'privacy-policy'

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center gap-0.5">
        <GoBackButton data-testid={`${testIdInit}-go-back-button`} />
        <Heading tag="h1">{t('privacy.title')}</Heading>
      </div>
      <PrivacyPolicy data-testid={`${testIdInit}-text`} />
    </div>
  )
}
